"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.goToContent = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _KesiConstants = require("../KESI2/KesiConstants");

var _KESI2Helper = _interopRequireDefault(require("../KESI2/KESI2Helper"));

var _strings = require("../../config/strings");

var _NavigationManagerCordova = _interopRequireDefault(require("../common/NavigationManagerCordova"));

var _AppUtils = require("../utils/AppUtils");

var _MuiAlertHelper = require("./MuiAlertHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

// eslint-disable-line
var showInvalidPathDialog = function showInvalidPathDialog() {
  var cancelButton = {
    label: (0, _strings.getString)('CANCEL')
  };
  (0, _MuiAlertHelper.showAlertWithOptions)({
    title: (0, _strings.getString)('ERROR'),
    message: (0, _strings.getString)('E_INVALID_PATH'),
    buttons: [cancelButton]
  });
};

var goToContent = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var uuids,
        expectedMd5,
        contents,
        contentPathArray,
        lastContentId,
        pathToGoTo,
        showContentNotAvailableDialog,
        updated,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            uuids = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
            expectedMd5 = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            contents = uuids.map(function (uuid) {
              return _KESI2Helper["default"].getContentByUuid(uuid);
            }).filter(function (c) {
              return c;
            });

            if (!(uuids.length !== contents.length || uuids.length === 0)) {
              _context.next = 6;
              break;
            }

            showInvalidPathDialog();
            return _context.abrupt("return");

          case 6:
            contentPathArray = contents.map(function (content) {
              return content.id;
            });
            lastContentId = contentPathArray[contentPathArray.length - 1];
            pathToGoTo = "".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId).concat(_KesiConstants.KESI_PATH_DELIMITER).concat(contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER));

            showContentNotAvailableDialog = function showContentNotAvailableDialog() {
              var online = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var cancelButton = {
                label: (0, _strings.getString)('CANCEL')
              };
              var tryAgainButton = {
                label: (0, _strings.getString)('TRY_AGAIN'),
                callback: function callback() {
                  return goToContent(uuids, expectedMd5);
                }
              };
              (0, _MuiAlertHelper.showAlertWithOptions)({
                title: online ? (0, _strings.getString)('ERROR') : (0, _strings.getString)('OFFLINE_TITLE'),
                message: online ? (0, _strings.getString)('ERROR_ON_CONTENT_UPDATE') : (0, _strings.getString)('ERROR_LOADING_CONTENT'),
                buttons: online ? [cancelButton, tryAgainButton] : [cancelButton]
              });
            };

            if (!(!_KESI2Helper["default"].getContentById(lastContentId) || expectedMd5 && !_KESI2Helper["default"].compareMd5OfContent(lastContentId, expectedMd5))) {
              _context.next = 21;
              break;
            }

            if (_DeviceInfoHelper["default"].isOnline()) {
              _context.next = 14;
              break;
            }

            showContentNotAvailableDialog(false);
            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return (0, _AppUtils.updateContent)();

          case 16:
            updated = _context.sent;
            console.log(updated);

            if (_KESI2Helper["default"].getContentById(lastContentId)) {
              _context.next = 21;
              break;
            }

            showContentNotAvailableDialog(true);
            return _context.abrupt("return");

          case 21:
            _NavigationManagerCordova["default"].goTo(pathToGoTo);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function goToContent() {
    return _ref.apply(this, arguments);
  };
}();

exports.goToContent = goToContent;